<template>
    <v-dialog v-model="show" max-width="500" persistent no-click-animation>
        <div class="block-relative">
            <loading-inside-component
                v-if="dataLoading"
            ></loading-inside-component>
            <v-form v-model="formValid" ref="form" @submit="submit">
                <div class="CallNowDialog">
                    <!-- Header dialog -->
                    <div class="dialog-header">
                        <div>Call Now</div>
                        <v-btn small icon @click="close">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>

                    <!-- Content dialog -->
                    <div class="dialog-content">
                        <!-- Name customer -->
                        <div class="centerY" style="flex-direction: column" v-if="model.customer">
                            <div class="icon-customer"><img src="/img/customer_call.svg" alt="icon-customer-call"></div>
                            <div style="font-size: 14px; font-weight: 600; margin-top: 4px">
                                {{ model.customer.name }}
                            </div>
                        </div>
                        <div class="centerY mt-12" style="gap: 8px">
                            <!-- Type voice profile -->
                            <div style="flex: 3">
                                <div class="label">{{ $f.tc("voiceProfile") }}</div>
                                <v-select
                                    v-model="model.selectedVoiceProfile"
                                    :items="voiceProfiles"
                                    :rules="formRules.required"
                                    class="input-custom"
                                >
                                    <template v-slot:item="{ item }">
                                        <v-tooltip v-if="item.voice.description" top>
                                            <template v-slot:activator="{ on }">
                                                <img v-if="item.voice.description"
                                                     src="/img/more_detail.svg"
                                                     alt="icon-more-detail" style="width: 15px;">
                                            </template>
                                            <span>{{ item.voice.description }}</span>
                                        </v-tooltip>
                                        <span :class="item.voice.description ? 'pl-6' : ''">{{
                                                item.voice.name
                                            }} - {{ item.speed }}</span>
                                    </template>
                                    <template v-slot:selection="{ item }" class="centerXY">
                                        <img v-if="item.voice.description" :title="item.voice.description"
                                             src="/img/more_detail.svg"
                                             alt="icon-more-detail" style="width: 15px;">
                                        <span :class="item.voice.description ? 'pl-6' : ''">{{ item.voice.name }} - {{
                                                item.speed
                                            }}</span>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                        <!-- Phone number -->
                        <div class="label">{{ $f.tc("phone") }}</div>
                        <v-select
                            v-model="model.phone"
                            :items="phoneList"
                            :rules="formRules.required"
                            class="input-custom"
                        ></v-select>

                        <!-- Service number -->
                        <div class="label" v-if="campaign.allow_test_service_number">{{ $f.tc("serviceNumber") }}</div>
                        <v-autocomplete
                            v-if="campaign.allow_test_service_number"
                            v-model="model.serviceNumber"
                            :items="serviceNumbers"
                            item-text="phone_number"
                            item-value="gid"
                            class="input-custom"
                            return-object
                            clearable
                        >
                            <template v-slot:item="{ item }">
                                <div class="centerY justify-space-between" style="width: 100%">
                                    <span>
                                        <span style="font-family: 'open sans bold', serif">{{
                                                item.phone_number
                                            }}</span>
                                        - {{ item.mobile_carrier.toUpperCase() }}
                                        <span v-if="item.group_sn_id">({{ item.group_sn_name }})</span>
                                    </span>
                                    <img
                                        v-if="checkSNCalled(item)"
                                        src="/img/called.svg"
                                        alt="icon-called"
                                        style="width: 20px"
                                        title="Called recently"
                                    >
                                </div>
                            </template>
                            <template v-slot:selection="{ item }">
                                <span>
                                    <span style="font-family: 'open sans bold', serif">{{ item.phone_number }}</span>
                                    - {{ item.mobile_carrier.toUpperCase() }}
                                    <span v-if="item.group_sn_id">({{ item.group_sn_name }})</span>
                                </span>
                            </template>
                        </v-autocomplete>
                    </div>

                    <!-- Dialog footer -->
                    <div class="dialog-footer">
                        <div class="btn-custom" @click="submit">
                            {{ $f.tc("call") }}
                        </div>
                        <div class="btn-outline" @click="close">
                            {{ $f.tc("cancel") }}
                        </div>
                    </div>
                </div>
            </v-form>
        </div>
    </v-dialog>
</template>
<script>
import LoadingInsideComponent from "@/components/LoadingInsideComponent";
import CampaignService from "@/services/campaign.service";
import FormMixin from "@/modules/fptai/mixins/FormMixin";
import {mapState} from "vuex";
import breakpoint from "vuetify/lib/components/Vuetify/mixins/breakpoint";

const defaultModel = {
    customer: null,
    selectedVoiceProfile: {},
    phone: "",
    serviceNumber: null
}

export default {
    name: "CallNowDialog",
    mixins: [FormMixin],
    components: {
        LoadingInsideComponent
    },
    data() {
        return {
            show: false,
            dataLoading: false,
            formValid: false,
            voiceProfiles: [],
            phoneList: [],
            serviceNumbers: [],
            model: this.$utils.cloneObject(defaultModel)
        };
    },
    computed: {
        ...mapState({
            campaign: state => state.campaign.campaign,
            serviceNumbersCalled: state => state.campaign.serviceNumbersCalled
        })
    },
    methods: {
        open(customer) {
            this.show = true;
            this.resetModel();
            if (customer) {
                this.model.customer = customer;
            }
            let min_priority = 10000;
            this.phoneList = customer.phone_numbers.map(phone => {
                if (phone.priority < min_priority) {
                    min_priority = phone.priority;
                    this.model.phone = phone.phone_number;
                }
                return {
                    text: phone.phone_number,
                    value: phone.phone_number
                };
            });
            this.getDataCall();
        },
        getDataCall() {
            let promises = [this.getVoiceProfiles()];
            if (this.campaign["allow_test_service_number"]) {
                promises.push(this.getServiceNumbers());
            }

            this.dataLoading = true;
            return Promise.all(promises).finally(() => {
                this.dataLoading = false;
            });
        },
        getServiceNumbers() {
            return CampaignService.getServiceNumbers(this.campaign).then(result => {
                this.serviceNumbers = result.data ? result.data.map(i => {
                    i.gid = i.group_sn_id ? `${i.id}_${i.group_sn_id}` : i.id
                    return i
                }) : []
            });
        },
        getVoiceProfiles() {
            return CampaignService.VoiceSpeedService.search(this.campaign.id).then(res => {
                this.voiceProfiles = res.data;
                if (this.voiceProfiles.length > 0) {
                    this.model.selectedVoiceProfile = this.voiceProfiles[0]
                    this.voiceProfiles.forEach(item => {
                        if (item.voice.default) {
                            this.model.selectedVoiceProfile = item
                        }
                    });
                }
            });
        },
        close() {
            this.resetModel();
            this.show = false;
        },
        submit(event) {
            if (event) {
                event.preventDefault();
            }

            if (!this.formValid) {
                this.$refs.form.validate();
                return
            }

            this.dataLoading = true;
            const i18n = {
                action: this.$t("select"),
                item: this.$t("voice")
            };
            let data = {
                voice: this.model.selectedVoiceProfile.voice.voice,
                phone_number: this.model.phone,
                voice_speed: this.model.selectedVoiceProfile.speed,
            }
            if (this.model.serviceNumber) {
                data.service_number_id = this.model.serviceNumber.id
                if (this.model.serviceNumber.group_sn_id) {
                    data.gns_id = this.model.serviceNumber.group_sn_id
                }
            }

            CampaignService.callNow(this.campaign, this.model.customer, data).then(() => {
                if (this.model.serviceNumber) {
                    this.$store.dispatch(this.$actionTypes.campaign.SAVE_SERVICE_NUMBER_CALLED, {
                        customerId: this.model.customer.id,
                        serviceNumberId: this.model.serviceNumber.gid
                    })
                }
                this.$appService.toastSuccess(this.$f.tc("actionSuccessful", i18n));
                this.$emit("success");
                this.close();
            }).finally(() => this.dataLoading = false);
        },
        resetModel() {
            this.voiceProfiles = [];
            this.phoneList = [];
            this.serviceNumbers = [];
            this.model = this.$utils.cloneObject(defaultModel)
        },
        checkSNCalled(item) {
            if (this.serviceNumbersCalled.length === 0 || !item || !this.model.customer) return false
            const itemExist = this.serviceNumbersCalled.find(i => i.customerId === this.model.customer.id)
            if (!itemExist) return false
            return itemExist.idCalledList.includes(item.gid)
        }
    },
    beforeDestroy() {
        this.resetModel();
    }
};
</script>
<style scoped lang="scss">
.CallNowDialog {
    background: #ffffff;
    border-radius: 5px !important;
    overflow: hidden;

    .btn-custom {
        margin-right: 8px;
    }

    .label {
        margin-top: 12px;
        margin-bottom: 3px !important;
        font-family: "open sans semi", serif;
        font-size: 13px;

        &:first-child {
            margin-top: 0 !important;
        }
    }

    .icon-customer {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        font-family: "open sans bold", serif;
        color: #FFFFFF;
        background: linear-gradient(90deg, #0052cc 0%, #2196f3 100%);

        img {
            width: 28px
        }
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #ffffff;
            border-radius: 5px;
            border: 1px solid #d9d9d9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            &:before,
            &:after {
                border: none !important;
            }
        }
    }
}

::v-deep {
    .v-slider__thumb-label {
        border-radius: 50% 50% 0;
        transform: translateY(-20%) translateY(-12px) translateX(-50%) rotate(45deg);
    }

    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
        position: relative;
    }

    .v-text-field__details {
        position: absolute;
        right: 12px;
        top: 10px;
    }

    .v-select {
        .v-text-field__details {
            right: 40px !important;
        }
    }
}
</style>
